import {
  ExpandableNavigationItemLogoProps,
  ExpandableNavigationItemIconProps,
  ExpandableNavigationItemLinkProps,
  ExpandableNavigationItemButtonProps,
} from './ExpandableNavigation';

export {
  ExpandableNavigationItem,
  ExpandableNavigationItemList,
  ExpandableNavigationItemIcon,
  ExpandableNavigationItemText,
  ExpandableNavigationItemLink,
  ExpandableNavigationItemLogo,
  ExpandableNavigation,
  ExpandableNavigationItemButton,
  ExpandableNavigationItemRightChild,
} from './ExpandableNavigation';

// https://github.com/babel/babel-loader/issues/603#issuecomment-418510348
// eslint-disable-next-line @trello/only-api-in-index
export type ExpandableNavigationItemLogoProps = ExpandableNavigationItemLogoProps;
// eslint-disable-next-line @trello/only-api-in-index
export type ExpandableNavigationItemIconProps = ExpandableNavigationItemIconProps;
// eslint-disable-next-line @trello/only-api-in-index
export type ExpandableNavigationItemLinkProps = ExpandableNavigationItemLinkProps;
// eslint-disable-next-line @trello/only-api-in-index
export type ExpandableNavigationItemButtonProps = ExpandableNavigationItemButtonProps;
